<template>
    <modal @close="cancel" dialog="modal-lg" class="dark-top heightAuto" :footer="false">
        <div slot="title">
            <h2 v-if="isNewAccount">Create Account</h2>
            <h2 v-else>Edit Account</h2>
        </div>

        <div slot="body" class="d-flex flex-column">
            <div class="form py-3 flexGrow1">
                <div class="col-sm-12">
                    <h5 class="w-100  d-flex justify-content-between">
                        <div>
                            User Info
                        </div>
                        <div v-if="accessPermissionFilter(['admin'])">
                            Active
                            <toggle-button class="ml-3" v-model="userAccount.isActive" :labels="{checked: 'Yes', unchecked: 'No'}" @input="activeStatusChanged" />
                        </div>
                    </h5>
                </div>

                <div class="form-group d-flex">
                    <div class="col-sm-3">
                        <avatar-uploader v-model="userAccount.imagePhotoBase64" :existingImg="userAccount.imagePhoto" placeholder="agent" @uploadComplete="addUploadedAvatar"></avatar-uploader>
                    </div>

                    <div class="col-sm-9">
                        <div class="row">

                            <div class="col-sm-6">
                                <label class="full">
                                    Name
                                    <input type="text" v-model="userAccount.name" @input="$v.userAccount.name.$touch">
                                </label>

                                <div v-if="$v.userAccount.name.$error" class="fs-small color-6">
                                    <span v-if="!$v.userAccount.name.required">Name is required.</span>
                                    <span v-if="!$v.userAccount.name.minLength">Name must have at least 3 characters</span>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <label class="full">
                                    Email
                                    <input type="text" v-model.trim="userAccount.email" @input="$v.userAccount.email.$touch" :disabled="!isNewAccount">
                                </label>

                                <div v-if="$v.userAccount.email.$error" class="fs-small color-6">
                                    <span v-if="!$v.userAccount.email.required">Email is required.</span>
                                    <span v-if="!$v.userAccount.email.email">Must be a valid email.</span>
                                    <span v-if="!$v.userAccount.email.isUnique">This email is already in use.</span>
                                </div>
                            </div>

                            <div class="col-sm-6 mt-3" v-if="selectedAccesType && accessPermissionFilter(['admin'])">
                                <label class="full">
                                    Access type
                                </label>
                                <v-select :options="getUserAccessTypes" v-model="selectedAccesType" @input="accessTypeChanged"></v-select>
                            </div>

                            <div class="col-sm-6 mt-3" v-if="getSalesChannels && accessPermissionFilter(['admin'])">
                                <label class="full">
                                    Sales Channel
                                </label>
                                <div v-if="userAccount.salesChannel">
                                    <v-select :options="possibleSalesChannels" v-model="userAccount.salesChannel" label="name"></v-select>
                                </div>
                                <div v-else>
                                    <button class="btn tertiary" @click="setSalesChannel">Set Sales Channel</button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="form-group d-flex" v-if="false">

                    <div class="col-sm-6">
                        <label class="full">
                            Name
                            <input type="text" v-model="userAccount.name" @input="$v.userAccount.name.$touch">
                        </label>

                        <div v-if="$v.userAccount.name.$error" class="fs-small color-6">
                            <span v-if="!$v.userAccount.name.required">Name is required.</span>
                            <span v-if="!$v.userAccount.name.minLength">Name must have at least 3 characters</span>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <label class="full">
                            Email
                            <input type="text" v-model.trim.lazy="userAccount.email" @blur="$v.userAccount.email.$touch" :disabled="!isNewAccount">
                        </label>

                        <div v-if="$v.userAccount.email.$error" class="fs-small color-6">
                            <span v-if="!$v.userAccount.email.required">Email is required.</span>
                            <span v-if="!$v.userAccount.email.email">Must be a valid email.</span>
                            <span v-if="!$v.userAccount.email.isUnique">This email is already in use.</span>
                        </div>
                    </div>

                </div>


                <div class="form-group d-flex" v-if="false">

                    <div class="col-sm-6" v-if="selectedAccesType">
                        <label class="full">
                            Access type
                        </label>
                        <v-select :options="getUserAccessTypes" v-model="selectedAccesType" @input="accessTypeChanged"></v-select>
                    </div>

                </div>

                <!-- <div class="form-group d-flex mt-5" v-if="!isNewAccount">

                    <div class="col-sm-12 d-flex justify-content-end">
                        <button class="btn action" @click="deleteAccount"><i class="ico ico-delete"></i> Delete Account</button>
                    </div>

                </div> -->

            </div>

            <div class="d-flex justify-content-between align-items-center mb-4 p-3">
                <div>
                    <button v-if="accessPermissionFilter(['admin'])" class="btn action wider" @click="deleteAccount"><i class="ico ico-delete"></i> Delete Account</button>
                </div>
                <div>
                    <button class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                    <button class="btn green wider" @click="save" :class="{'opacity-50': isFormInvalid}">{{loading? 'Saving...' : 'Save'}}</button>
                </div>
            </div>

        </div>
    </modal>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import extendedVSelect from '@/extends/vue-select'
    import Modal from './Modal'
    import AvatarUploader from '@/tools/AvatarUploader'

    export default {
        data: function () {
            return {
                loading: false,
                userAccount: null,
                selectedAccesType: null
            }
        },
        created: function() {
            // Checks if is a new account or an existing one
            if(this.isNewAccount){
                // When creating a new account we start with a virgin template
                this.setUserAccountVirgin()
            } else {
                // Loads selected account info from store
                this.setUserAccountStored()
            }

            // Sets te correct accessType as selected
            this.setSelectedAccessType(this.userAccount.userAccountTypeDefault)
        },
        validations: {
            userAccount: {
                email: {
                    required,
                    email,
                    isUnique: function() {
                        return this.isUniqueEmail() || true
                    }
                },
                name: {
                    required,
                    minLength: minLength(3)
                }
            }
        },
        computed: {
            ...mapGetters([
                'getUserAccessTypes',
                'getSupplierAccountVirgin',
                'getSelectedSupplierAccount',
                'account',
                'getSalesChannels'
            ]),
            possibleSalesChannels: function () {
                let allowedSalesChannelTypes = new Array(0, 9999)
                return this.getSalesChannels.filter(salesChannel => {
                    return allowedSalesChannelTypes.includes(salesChannel.channelType)
                })
            },
            isNewAccount: function() {
                return this.getSelectedSupplierAccount == null
            },
            isFormInvalid: function() {
                return this.$v.userAccount.$invalid
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createSupplierAccount',
                'editSupplierAccount',
                'setStatusSupplierAccount',
                'deleteSupplierAccount',
                'refreshAccountData',
                'downloadSupplierAccounts'
            ]),
            addUploadedAvatar: function() {
                console.log('addUploadedAvatar');
            },
            setUserAccountVirgin: function() {
                this.$set(this, 'userAccount', JSON.parse(JSON.stringify(this.getSupplierAccountVirgin)))
                console.log('this.userAccount', this.userAccount);
            },
            setUserAccountStored: function() {
                this.$set(this, 'userAccount', this.getSelectedSupplierAccount)
            },
            createNewAccount: function () {
                this.loading = true
                this.createSupplierAccount(this.userAccount).then(r => {
                    this.loading = false
                    if (r) {
                        this.downloadSupplierAccounts()
                        this.closeModal();
                    } else {
                        this.$toasted.error('Error creating account, check everything and try again.');
                    }
                }).catch(error => {
                    this.loading = false
                })
            },
            updateAccount: function () {
                this.loading = true
                this.editSupplierAccount(this.userAccount).then(response => {
                    this.loading = false
                    if (response.status == 200) {
                        //if the edited user is the current user we update the stored data
                        if(response.data.id == this.account.id){
                            console.log('update current user');
                            this.refreshAccountData()

                        }
                        this.downloadSupplierAccounts()
                        this.closeModal();
                    } else {
                        this.$toasted.error('Error editing account, check everything and try again.');
                    }
                }).catch(error => {
                    this.loading = false
                })
            },
            changeStatusAccount: function (action) {
                this.setStatusSupplierAccount({
                    userAccount: this.userAccount,
                    action: action,
                }).then(r => {
                    if (r) {
                        // this.closeModal();
                    } else {
                        this.$toasted.error('Error changing account status, check everything and try again.');
                    }
                })
            },
            deleteAccount: function () {
                let vm = this
                this.$dialog.confirm('<b>Delete Account?</b><br>This action is irreversible!')
                .then(function () {
                    // yes
                    vm.deleteSupplierAccount(vm.userAccount).then( r => {
                        if(r){
                            vm.$toasted.info('Account deleted');
                            vm.closeModal()
                        }
                    })
                })
                .catch(function () {
                    // no
                });
            },
            isUniqueEmail: _.debounce( function(){

                    let email = this.userAccount.email;

                    if (email != '') {

                        // If it is an existing accout the email is always valid
                        if(!this.isNewAccount){
                            return true
                        }

                        return axios.get(axios.authURL + 'auth/IsEmailFree', {
                             params: {
                                 email: email
                             }
                        }).then(response => {
                            if (response && response.status === 200) {
                                return response.data.isSuccessStatusCode;
                            }
                        }).catch(error => {
                            console.log(error.response.data.message);
                            return false
                        })
                    } else {
                        return false;
                    }

                },
                500
            ),
            accessTypeChanged: function(selectedAccesType) {
                // console.log(selectedAccesType.id, this.selectedAccesType.id);
                if(selectedAccesType !== null){
                    // this.userAccount.userAccountTypes[0].accessType = selectedAccesType.id
                    this.$set(this.userAccount.userAccountTypes[0], 'accessType', selectedAccesType.id)
                } else {
                    // if the same value is selected sets the slectedion as "Basic User" instead of null and nuking the form
                    this.userAccount.userAccountTypes[0].accessType = this.getUserAccessTypes[1].id
                    this.selectedAccesType = this.getUserAccessTypes[1]
                }
            },
            setSelectedAccessType: function(userAccountType) {
                this.selectedAccesType = this.getUserAccessTypes.filter(accessType => {
                    return accessType.id == userAccountType.accessType
                })[0]


                //if none is found set as accessType 2 (basic user)
                if(this.selectedAccesType === undefined){
                    this.selectedAccesType = this.getUserAccessTypes.filter(accessType => {
                        return accessType.id == 2
                    })[0]
                }
            },
            setSalesChannel: function () {
                this.$set(this.userAccount, 'salesChannel', this.getSalesChannels[0])
            },
            activeStatusChanged: function (isActive){
                // if(isActive){
                //     this.changeStatusAccount('activate')
                // } else {
                //     this.changeStatusAccount('disable')
                // }
            },
            cancel: function() {
                this.closeModal();
            },
            save: function() {
                if(this.loading){
                    return false
                }

                if(this.isFormInvalid){
                    this.$toasted.error('Check all fields and try again')
                    return false
                }
                // Checks if is a new account or an existing one
                if(this.isNewAccount){
                    // Create account
                    this.createNewAccount()
                } else {
                    // Edit Account
                    this.updateAccount()
                }
            }
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            AvatarUploader
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

</style>



// WEBPACK FOOTER //
// supplierAccountModal.vue?2b2d96fe